import { TProductCategory } from "@components/types";
import { getSafeUrl, sanityIoImageLoader, staticImageLoader } from "@core/utils";
import Image from "next/image";
import Link from "next/link";
import React from "react";

type Props = {
    product: TProductCategory;
    loading?: "lazy" | "eager"
};


export const CategoryCard: React.FC<Props> = ({ product, loading }) => {
    return (
        <div className="relative flex-shrink-0 w-32">
            <div className="p-2 w-full text-center flex flex-col justify-end gap-1">
                <div className="flex justify-center rounded-full bg-brand-100">
                    <Link href={`/category/${product.id}/${getSafeUrl(product.name)}`} prefetch={false}>
                        <Image
                            loader={product.image ? sanityIoImageLoader : staticImageLoader}
                            src={product.image || "https://cdn.jhattse.com/public/consumer/placeholder/category_circular.png"}
                            alt={product.name}
                            width="128"
                            height="128"
                            className="rounded-full h-full aspect-square"
                            loading={loading}
                        />
                    </Link>
                </div>
                <Link href={`/category/${product.id}/${getSafeUrl(product.name)}`} prefetch={false}>
                    <div className="overflow-hidden line-clamp-2 md:line-clamp-none">
                        <p className="font-manrope font-semibold text-neutral-900 text-sm text-ellipsis text-center leading-tight">{product.name}</p>
                    </div>
                </Link>
            </div>
        </div>
    )
}